import { propsMap, nestedPropsMap } from '@/presentation/interfaces';

export enum InputType {
  primary = 'primary',
  secondary = 'secondary',
  minimal = 'minimal',
}

export enum InputSizes {
  s = 's',
  m = 'm',
}

export const sizes: propsMap = {
  s: '19.25rem',
  m: '27.5rem',
};

export const iconSizes: propsMap = {
  s: '0.821rem',
  m: '1.094rem',
};

export const borderRadius: propsMap = {
  s: '0.156rem',
  m: '0.313rem',
};

export const spacings: nestedPropsMap = {
  s: {
    horizontal: '0.938rem',
    vertical: '0.547rem',
    bottom: '1.25rem',
    withIcon: '2.383rem',
  },
  m: {
    horizontal: '0.938rem',
    vertical: '0.938rem',
    bottom: '1.406rem',
    withIcon: '3.906rem',
  },
};

export const fontSizes: nestedPropsMap = {
  label: {
    s: '0.625rem',
    m: '0.781rem',
  },
  input: {
    s: '0.781rem',
    m: '0.938rem',
  },
  error: {
    s: '0.625rem',
    m: '0.781rem',
  },
};

export const letterSpacings: nestedPropsMap = {
  label: {
    s: '0.006rem',
    m: '0',
  },
  input: {
    s: '0',
    m: '0.013rem',
  },
  error: {
    s: '0.006rem',
    m: '0',
  },
};

export const lineHeights: nestedPropsMap = {
  label: {
    s: '0.938rem',
    m: '1.094rem',
  },
  input: {
    s: '1.094rem',
    m: '1.25rem',
  },
  error: {
    s: '0.938rem',
    m: '1.094rem',
  },
};
